import { VerticalView } from 'src/components/FlexViews';
import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  position: relative;
`;

export const Title = styled.h1`
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin: 0;
  position: absolute;
  left: 0;
  right: 0;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1;
`;

export const PlaceholderDiv = styled.div`
  width: 24px;
  height: 24px;
`;

export const InfoCard = styled.div`
  background-color: #53596240;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
`;

export const InfoText = styled.p`
  color: #b4bbc3;
  text-align: center;
  font-size: 12px;
  margin-bottom: 20px;
  line-height: 1.5;
`;

export const PromoCodeContainer = styled.div`
  background-color: #00000040;
  border-radius: 12px;
  padding: 14px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const PromoCode = styled.div`
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  flex: 1;
  text-align: center;
  margin-left: 15px;
`;

export const CopyButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #c4f538;
`;

export const InviteButton = styled.button`
  background-color: #c4f538;
  border: none;
  border-radius: 12px;
  padding: 14px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #000000;
  cursor: pointer;
`;

export const StatsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const StatLabel = styled.div`
  color: #8b9299;
  font-size: 12px;
`;

export const StatValue = styled.div`
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const SectionTitle = styled.div`
  color: #8b9299;
  font-size: 14px;
  margin-bottom: 16px;
`;

export const ReferralsContainer = styled.div`
  background-color: #20242b;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100px;
`;

export const NoReferralsText = styled.div`
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const ReferralHelper = styled.div`
  color: #b4bbc380;
  font-size: 12px;
  text-align: center;
`;

export const ReferralItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  gap: 12px;
  border-radius: 12px;
  background: #212730;
  margin-bottom: 8px;
`;

export const MedalWrapper = styled.div`
  position: relative;
`;

export const MedalPosition = styled.p`
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
  font-family: Public-Sans, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 12px;
  color: rgba(0, 0, 0, 0.8);
  text-align: center;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Username = styled.div`
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
`;

export const EarningsValue = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
`;
